import React, { useState } from 'react';

import useAppNavigation from '~/hooks/useAppNavigation';

import TagCreate from './TagCreate';
import TagEdit from './TagEdit';
import TagsList from './TagsList';

export default function Tags() {
  const { push } = useAppNavigation();
  const [view, setView] = useState<'list' | 'create' | 'edit'>('list');
  const [selectedTagId, setSelectedTagId] = useState<string | null>(null);

  const handleBack = () => {
    setView('list');
    setSelectedTagId(null);
  };

  const handleCreate = () => {
    setView('create');
    setSelectedTagId(null);
  };

  const handleEdit = (tagId: string) => {
    setView('edit');
    setSelectedTagId(tagId);
  };

  const handleViewContent = (tagName: string) => {
    push(`/marketing/content?query=${encodeURIComponent(tagName)}`);
  };

  return (
    <>
      {view === 'create' && <TagCreate onBack={handleBack} />}
      {view === 'edit' && selectedTagId && (
        <TagEdit tagId={selectedTagId} onBack={handleBack} onViewContent={handleViewContent} />
      )}
      {view === 'list' && <TagsList onCreate={handleCreate} onEdit={handleEdit} onViewContent={handleViewContent} />}
    </>
  );
}
